import { getUnixTime, fromUnixTime } from 'date-fns';
import { AGENT_API } from '../AgentAPI';
import { convertUnixToDate, AnnouncementType, createBranch, Branch } from '@golden/gdk-base';
import { map, distinctUntilChanged } from 'rxjs';
import { isEqual } from '@golden/utils';
export function createAnnouncementService(api, trunk) {
    return {
        announcements: createBranch({
            trunk,
            branch: Branch.ANNOUNCEMENT,
            value: null,
            operator: (obs) => obs.pipe(() => api.fetch(AGENT_API.GET_ANNOUNCEMENT), distinctUntilChanged((a, b) => isEqual(a, b)), map((res) => res.map((el) => convertUnixToDate(el, 'created_at', 'updated_at', 'begin_at', 'end_at'))))
        }),
        readAnnouncement(ids) {
            return api.fetch(AGENT_API.POST_ANNOUNCEMENT_READ, { data: { ids } });
        },
        readAllAnnouncement() {
            return api.fetch(AGENT_API.POST_ANNOUNCEMENT_READ_ALL);
        },
        staffAnnouncements: createBranch({
            trunk,
            branch: Branch.STAFF_ANNOUNCEMENT,
            value: null,
            operator: (obs) => obs.pipe(() => api.fetch(AGENT_API.GET_STAFF_ANNOUNCEMENT_ALL), map((res) => res.map((el) => ({
                ...convertUnixToDate(el, 'created_at', 'updated_at', 'begin_at', 'end_at'),
                type: AnnouncementType.STAFF,
                is_pinned: false,
                is_pop_up: false,
                is_marquee: false,
                is_finance: false
            }))))
        }),
        readStaffAnnouncement(ids) {
            return api.fetch(AGENT_API.POST_STAFF_ANNOUNCEMENT_READ, { data: { ids } });
        },
        readAllStaffAnnouncement() {
            return api.fetch(AGENT_API.POST_STAFF_ANNOUNCEMENT_READ_ALL);
        },
        getStaffAnnouncement() {
            return api.fetch(AGENT_API.GET_STAFF_ANNOUNCEMENT).pipe(map((el) => ({
                ...el,
                begin_at: el.begin_at ? fromUnixTime(el.begin_at) : null,
                end_at: el.end_at ? fromUnixTime(el.end_at) : null
            })));
        },
        updateStaffAnnouncement(payload) {
            const data = {
                ...payload,
                begin_at: getUnixTime(payload.begin_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(AGENT_API.POST_STAFF_ANNOUNCEMENT, { data });
        }
    };
}
//# sourceMappingURL=AnnouncementService.js.map